import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { autobind } from 'core-decorators'
import classNames from 'classnames'
import ReactTooltip from 'react-tooltip'
import { deepGet } from '../utils'
import Icon from './Icon'
import WorkflowToolsContainer from '../containers/WorkflowTools'
import { debounce } from '../libs/debounce'

const debouncedTooltipRebuild = debounce(() => {
  ReactTooltip.rebuild()
}, 300)

export default class FormGroup extends Component {

  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    info: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    note: PropTypes.string,
    onChange: PropTypes.func,
  }

  static contextTypes = {
    dirty: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.bool
    ]),
    getRejectionMessage: PropTypes.func
  }

  componentDidMount() {
    debouncedTooltipRebuild()
  }

  componentDidUpdate() {
    debouncedTooltipRebuild()
  }

  @autobind
  handleReject(e) {
    this.handleChange(e)
  }

  @autobind
  handleChange(e) {
    if (this.props.onChange) {
      e.stopPropagation && e.stopPropagation()
      this.props.onChange(e)
    }
  }

  render() {
    const {
      className,
      info,
      label,
      name,
      note
    } = this.props

    const { dirty } = this.context

    const isDirty = dirty
      && Object.prototype.toString.apply(dirty) === '[object Object]'
      && deepGet(dirty, name)

    const formGroup = (
      <div
        className={classNames('form-group', className, {
          dirty: isDirty
        })}
        onChange={this.handleReject}
      >
        <label
          className="col-xs-4"
          htmlFor={name}
        >
          {label}
          {
            info
              ? (
                <span>
                  <span
                    className="info-icon"
                    data-tip={info}
                  >
                    <Icon
                      name="info"
                      size={18}
                    />
                  </span>
                  {note ? <span className="info">{note}</span> : null}
                </span>
              )
              : null
          }
        </label>
        {this.props.children}
      </div>
    )

    if (!isDirty) {
      return formGroup
    }

    return (
      <WorkflowToolsContainer
        context={this.context}
        label={label}
        name={name}
        onChange={this.handleReject}
      >
        {formGroup}
      </WorkflowToolsContainer>
    )
  }

}



// WEBPACK FOOTER //
// ./src/shared/components/FormGroup.js